import React, { HTMLAttributes } from 'react';

import { CoreLink, Icon } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphTextEntity } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphTextEntity;
}

const ParagraphFrontPageProgram: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('ParagraphFrontPageProgram');

  const program: string = String(entity.getIn(['field_program', 0, 'value'], ''));
  const guidedLinkUri: string = String(entity.getIn(['field_guided_link', 0, 'uri'], ''));
  const guidedLinkTitle: string = String(entity.getIn(['field_guided_link', 0, 'title'], ''));
  const linkUri: string = String(entity.getIn(['field_link', 0, 'uri'], ''));
  const linkTitle: string = String(entity.getIn(['field_link', 0, 'title'], ''));

  return (
    <article className={joinClasses(className, buildClass())}>
      <CoreLink to={linkUri}>
        <div className={buildClass('card')}>
          <div className={buildClass('icon-container')}>
            <Icon icon={program} variant="2" size="lg" />
          </div>
          <div className={buildClass('program')}>
            {linkTitle}
          </div>
        </div>
      </CoreLink>
      <div className={buildClass('link-container')}>
        <CoreLink to={guidedLinkUri} className={joinClasses(buildClass('link'), 'textual-link')} title={guidedLinkTitle} />
      </div>
    </article>
  );
};

export default ParagraphFrontPageProgram;
